import { Outlet } from "react-router-dom";
import Header from "../../components/common/Header";
import Sidebar from "../../components/common/Sidebar";
import Footer from "../../components/common/Footer";

const VendorLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header />

      {/* Main content area */}
      <div className="flex flex-1 min-h-0">
        <aside className="flex-shrink-0 self-stretch">
          <Sidebar />
        </aside>

        <main className="flex-1 overflow-y-auto">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Footer stays at the bottom */}
      <Footer vendor={true} />
    </div>
  );
};

export default VendorLayout;
